import { Subscription } from "rxjs";
import {
  Component,
  HostBinding,
  OnInit,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { LoaderService } from "../../global/loader.service";
import { SessionService } from "../../global/session.service";
import { NavigationEnd, NavigationStart, Router, Event as RouterEvent } from "@angular/router";

import { navItems } from "./_nav";
import { RESTRICTED_ROLE_SECTIONS } from "../../global/roles";
import { ScrollService } from "../../global/scroll.service";
import { PendingRequestsService } from "../../global/pending-request.service";
import { distinctUntilChanged, filter } from "rxjs/operators";

@Component({
  selector: "app-dashboard",
  styleUrls: ["./default-layout.component.scss"],
  templateUrl: "./default-layout.component.html",
})
export class DefaultLayoutComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @HostBinding("class.c-app") cAppClass = true;

  private routerEventsSub: Subscription;
  private popStateListener: () => void;
  private pendingSub: Subscription;
  private lastNavigationUrl: string = null;
  private previousUrl: string = null;
  private pendingRestoreUrl: string = null;
  public navItems = navItems;

  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  public showLoader = null;
  public showMessage = null;

  userRole: string = null;

  constructor(
    private router: Router,
    private scrollService: ScrollService,
    private loaderService: LoaderService,
    public session: SessionService,
    private pendingRequests: PendingRequestsService
  ) {
    console.warn(this.navItems);
    this.userRole = this.session.checkRole();
    // Only Grab Data if user role has access
    // Role = 1 is admin, show all
    // Role = 2 is warehouse, only show orders
    // Role = 3 is finance, only show customers

    // Managing admin users is restricted to the admin role.
    if (this.userRole != "1") {
      this.navItems = this.navItems.filter((nav) => nav.name != "Admin Users");
    }

    if (this.userRole == "2") {
      this.navItems = this.navItems.filter((nav) => nav.name != "Customers");
    }

    if (this.userRole == "3") {
      this.navItems = this.navItems.filter((nav) => nav.name != "Orders");
      this.navItems = this.navItems.filter((nav) => nav.name != "Credit Notes");
    }

    if (this.userRole === "8") {
      console.log({ items: this.navItems });

      this.navItems = this.navItems.reduce((acc, nav) => {
        if (nav.name === "Log Out") {
          acc.push(nav);
        }

        return acc;
      }, []);
    }

    // Product Administrator and Dispatch Operator only get their own section.
    const restrictedSection = RESTRICTED_ROLE_SECTIONS[this.userRole];

    if (restrictedSection) {
      this.navItems = this.navItems.filter(
        (nav) => nav.name === restrictedSection.navName || nav.name === "Log Out"
      );
    }
  }

  ngOnInit(): void {
    this.loaderService.showLoader.subscribe((showLoader) => {
      this.showLoader = showLoader;
    });

    this.loaderService.showMessage.subscribe((showMessage) => {
      this.showMessage = showMessage;
    });
  }

  ngAfterViewInit() {
    // Listen to router events for scroll saving/restoration
    this.routerEventsSub = this.router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationStart) {
        // Save scroll position for the current URL
        this.scrollService.setPosition(this.router.url, window.scrollY);
        // Unsubscribe from any previous pending$ subscription
        if (this.pendingSub) this.pendingSub.unsubscribe();
        // Reset pendingRestoreUrl
        this.pendingRestoreUrl = null;
        // Store previous URL
        this.previousUrl = this.router.url;
      }
      if (event instanceof NavigationEnd) {
        this.lastNavigationUrl = this.router.url;
        // Always try to restore scroll for the current URL
        this.restoreScroll(this.lastNavigationUrl);
      }
    });

    // Listen to browser back/forward navigation (popstate)
    this.popStateListener = () => {
      // Use setTimeout to wait for Angular to update the route
      setTimeout(() => {
        const url = this.router.url;
        this.restoreScroll(url);
      }, 0);
    };
    window.addEventListener('popstate', this.popStateListener);
  }

  private restoreScroll(url: string) {
    // Wait for pending requests to finish before restoring scroll
    if (this.pendingSub) this.pendingSub.unsubscribe();
    this.pendingSub = this.pendingRequests.pending$
      .pipe(
        distinctUntilChanged(),
        filter((pending) => !pending)
      )
      .subscribe(() => {
        const pos = this.scrollService.getPosition(url);
        if (pos !== undefined) {
          setTimeout(() => {
            window.scrollTo({ top: pos, behavior: "auto" });
          }, 0);
        } else {
          window.scrollTo({ top: 0, behavior: "auto" });
        }
        if (this.pendingSub) {
          this.pendingSub.unsubscribe();
          this.pendingSub = null;
        }
      });
  }

  ngOnDestroy() {
    if (this.routerEventsSub) this.routerEventsSub.unsubscribe();
    if (this.pendingSub) this.pendingSub.unsubscribe();
    if (this.popStateListener) window.removeEventListener('popstate', this.popStateListener);
  }
}
